import { SHIPPER_GUIDE_API_URL } from 'core/infra/environment'
import { HttpClient, createTokenInterceptor } from 'core/infra/http/HttpClient'
import { LocalStorageClient } from 'core/infra/storage/LocalStorageClient'

import { AgnosticUserRepository } from './AgnosticUserRepository'

export function createAgnosticHttpClient() {
  const storage = new LocalStorageClient()
  const userRepository = new AgnosticUserRepository({ storage })
  const httpClient = new HttpClient(SHIPPER_GUIDE_API_URL, {
    requestInterceptor: createTokenInterceptor({ userRepository }),
    responseInterceptor: null,
  })

  return httpClient
}
